import clsx from 'clsx'

const normalizeStatus = status => {
  if (status === 0 || status == null) return ''

  return String(status)
    .toUpperCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/_/g, ' ')
    .trim()
}

const getStatusKey = status => {
  const normalized = normalizeStatus(status)

  if (!normalized) return 'UNKNOWN'
  if (normalized.includes('PARCIAL')) {
    if (normalized.includes('PAG')) return 'PARCIAL_PAGADO'
    if (normalized.includes('COBR')) return 'PARCIAL_COBRADO'
    if (normalized.includes('CONCILI')) return 'PARCIAL_CONCILIADO'
  }
  if (normalized.includes('POR PAG')) return 'POR_PAGAR'
  if (normalized.includes('POR COB')) return 'POR_COBRAR'
  if (normalized.includes('PAGADO')) return 'PAGADO'
  if (normalized.includes('COBRADO')) return 'COBRADO'
  if (normalized.includes('CONCILIADO')) return 'CONCILIADO'

  return normalized
}

const getStatusLabel = status => {
  const key = getStatusKey(status)

  if (key === 'PARCIAL_PAGADO') return 'PARCIALMENTE PAGADO'
  if (key === 'PARCIAL_COBRADO') return 'PARCIALMENTE COBRADO'
  if (key === 'PARCIAL_CONCILIADO') return 'PARCIALMENTE CONCILIADO'
  if (key === 'POR_PAGAR') return 'POR PAGAR'
  if (key === 'POR_COBRAR') return 'POR COBRAR'
  if (key === 'PAGADO') return 'PAGADO'
  if (key === 'COBRADO') return 'COBRADO'
  if (key === 'CONCILIADO') return 'CONCILIADO'

  return key === 'UNKNOWN' ? '—' : key
}

const getStatusBadgeClass = status => {
  const key = getStatusKey(status)
  const isPending = key === 'POR_PAGAR' || key === 'POR_COBRAR'
  const isPaid = key === 'PAGADO' || key === 'COBRADO' || key === 'CONCILIADO'
  const isPartial =
    key === 'PARCIAL_PAGADO' ||
    key === 'PARCIAL_COBRADO' ||
    key === 'PARCIAL_CONCILIADO'

  return clsx(
    'inline-flex items-center justify-center rounded-full px-3 py-1 text-[0.6rem] sm:text-[0.65rem] font-semibold uppercase tracking-wider leading-tight',
    {
      'text-danger bg-danger/10': isPending,
      'text-success bg-success/10': isPaid,
      'text-amber-700 bg-amber-100': isPartial,
      'text-muted bg-border/40': !isPending && !isPaid && !isPartial
    }
  )
}

export { getStatusBadgeClass, getStatusLabel }
